define(['jquery', 'lodash/debounce'], function($, debounce) {
    'use strict';


    // adds a CSS helper class to any footer block that would be an expandable.
    $('.js-mobile-expandable > div + div').addClass('js-mobile-expandable__content');

    // Mobile expandable functionality for footer menus
    $(document).on('click', '.page-footer .js-mobile-expandable h5', function(e) {
        $(e.target)
            .closest('.js-mobile-expandable')
            .toggleClass('is-open-mobile');
    });

    // Go to top of page
    $('<a class="footer-scroll-top d-none" href="#top"></a>').insertBefore('.page-footer');
    $('.footer-scroll-top').click(function() {
        $('html, body').animate({
            scrollTop: 0
        });
        return false;
    });

    window.addEventListener(
        'scroll',
        debounce(function() {
            if (window.scrollY > 500) {
                $('.footer-scroll-top').removeClass('d-none');
            } else {
                $('.footer-scroll-top').addClass('d-none');
            }
        }, 50)
    );
});
